import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AccountPlusOutlineIcon from 'mdi-react/AccountPlusOutlineIcon';
import renderSearchSelectField from '../../../shared/components/custom/SearchSelect';
import Api from '../../../util/api';
import { partial } from '../../../util/translation/translation';
import useConfig from '../../../util/useConfig';

const AddRoleForm = (props) => {
  const config = useConfig();

  const p = partial('UserRolesTab');
  const s = partial('shared');
  const { handleSubmit, reset, disabled } = props;
  const [userOptions, setUserOptions] = useState([]);

  const getUser = async (text) => {
    const { users } = await Api.users.getTeamUsers(
      1,
      20,
      { phoneNumber: 'asc' },
      text,
      config
    );
    const _userOptions = users.map((user) => {
      return {
        label: `${user.firstname} ${user.lastname} (${user.username})`,
        value: {
          ...user,
          teamUserId: user.teams[0].id,
        },
      };
    });
    setUserOptions(_userOptions);
  };

  // Empty the search once the user has been added
  const _handleSubmit = (event) => {
    const result = handleSubmit(event);
    if (result?.then) result.then(() => reset());
  };

  return (
    <form className="role-add" onSubmit={_handleSubmit}>
      <span className="role-add__label">{p('addUserToRole')}</span>
      <div className="role-add__row">
        <div className="role-add__select">
          <Field
            name="selectedUser"
            component={renderSearchSelectField}
            placeholder={s('searchNameOrNumber')}
            options={userOptions}
            search={getUser}
          />
        </div>
        <Button
          type="submit"
          color="primary"
          className="role-add__submit mb-0"
          disabled={!props.formValues?.selectedUser || disabled}
        >
          <AccountPlusOutlineIcon />
          {p('assign')}
        </Button>
      </div>
    </form>
  );
};

AddRoleForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  formValues: PropTypes.shape({
    selectedUser: PropTypes.shape({
      label: PropTypes.string,
      values: PropTypes.any,
    }),
  }),
};

AddRoleForm.defaultProps = {
  disabled: false,
  formValues: {},
};

const reduxF = reduxForm({
  form: 'users_by_role_form',
});

export default connect((state) => ({
  formValues: getFormValues('users_by_role_form')(state),
}))(reduxF(AddRoleForm));
